import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "title", label: "Titre", required: true },
  { key: "description", label: "Description", type: "textarea" },
  { key: "icon", label: "Icône", type: "icon" },
  { key: "image", label: "Image (URL)", type: "image" },
];

export default function AdminMissions() {
  return (
    <AdminCrud
      title="Missions"
      description="Les cartes « Nos missions » affichées sur la page d'accueil."
      addLabel="Ajouter une mission"
      table="missions"
      fields={fields}
      listTitleKey="title"
      listImageKey="image"
    />
  );
}